import React from "react";
import { PieChart, Pie, Tooltip, Legend, Cell, Text } from "recharts";
import "./portcoChart.css";
import "../../common/css/component.css";

const rootStyles = getComputedStyle(document.documentElement);
const colors = [
    rootStyles.getPropertyValue("--chart-color-1").trim(),
    rootStyles.getPropertyValue("--chart-color-2").trim(),
    rootStyles.getPropertyValue("--chart-color-3").trim(),
    rootStyles.getPropertyValue("--chart-color-4").trim(),
    rootStyles.getPropertyValue("--chart-color-5").trim(),
    rootStyles.getPropertyValue("--chart-color-6").trim(),
];

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <p><span className="bold-label">Fund Name:</span> {`${payload[0].payload.fund_name}`}</p>
        <p><span className="bold-label">Total Portfolio Companies:</span> {`${payload[0].payload.num_portfolio_companies}`}</p>
        <p><span className="bold-label">Total Investment:</span> {`${currencyFormatter.format(payload[0].payload.total_investment)}`}</p>
      </div>
    );
  }

  return null;
};


const PortcoChart = ({ data, isDonut = true, dataKey = 'total_investment' }) => {
  if (!Array.isArray(data)) {
    return <div>No data available.</div>;
  }
  const formattedData = data.map(item => ({...item, name: item.fund_name}));

  const totalInvestment = formattedData.reduce((sum, item) => sum + item.total_investment, 0);
  const formattedTotalInvestment = currencyFormatter.format(totalInvestment);
  const totalCompanies = formattedData.reduce((sum, item) => sum + item.num_portfolio_companies, 0);
  

  const CustomLegend = ({ payload, data }) => {
    return (
      <div className="custom-legend">
        {
          payload.map((entry, index) => (
            <div key={`item-${index}`} className="custom-legend-item" >
              <span style={{backgroundColor: entry.color}}></span>
              {data[index].fund_name}
            </div>
          ))
        }
      </div>
    );
  };

  return (
    <div className="component-container-no-border">
      <PieChart width={400} height={400} style={{ marginTop: '10px'}}>
        <Pie
          dataKey={dataKey}
          isAnimationActive={true}
          data={data}
          cx="50%"
          cy="50%"
          outerRadius={150}
          innerRadius={isDonut ? 100 : 0} 
          fill={colors[0]}
          labelLine={false}
        >
        {formattedData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
        ))}
        </Pie>
        {isDonut &&
          <g>
            <text x={200} y={210} textAnchor="middle" dominantBaseline="middle" className="donut-center-text">
              Total Investment:
            </text>
            <text x={200} y={230} textAnchor="middle" dominantBaseline="middle" className="donut-center-text">
              {formattedTotalInvestment}
            </text>
            <text x={200} y={260} textAnchor="middle" dominantBaseline="middle" className="donut-center-text">
              Total Companies: {totalCompanies}
            </text>
          </g>
        }


        <Tooltip content={<CustomTooltip />} />
        <Legend 
            wrapperStyle={{ marginBottom: '100px' }} 
            content={<CustomLegend data={data} />}
            layout="horizontal"
            align="center"
            verticalAlign="top"
        />
      </PieChart>
    </div>

  );
};

export default PortcoChart;
